package com.nonopn.skydome.common.app.pages.densities

import com.nonopn.dispatchers.DefaultDispatcher
import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.pages.main.model.LoadStrikeRadarData
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skydome.common.app.pages.main.model.api.SectionProjectAndThunderDetection
import com.nonopn.skydome.common.app.pages.main.model.api.ThunderDetectionActivity
import com.nonopn.skywatcher.app.file.saveFile
import com.nonopn.skywatcher.common.api.ApiSession
import com.nonopn.skywatcher.design.widgets.abslists.AbstractListModel
import com.nonopn.skywatcher.design.widgets.abslists.AbstractListModelState
import com.nonopn.skywatcher.design.widgets.abslists.ListModelState
import com.nonopn.skywatcher.design.widgets.abslists.ListModelStateHolder
import com.nonopn.skywatcher.design.widgets.endOfDay
import com.nonopn.skywatcher.design.widgets.startOfDay
import eu.codlab.viewmodel.launch
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import korlibs.time.hours
import korlibs.time.minutes
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.async
import ovh.plrapps.mapcompose.api.ExperimentalClusteringApi

data class DensitiesModelState(
    val loading: Boolean = false,
    val initialized: Boolean = false,
    val apiSession: ApiSession? = null,
    val selectedDate: DateTimeTz,
    val selectedDateFullDay: Boolean = true,
    override val modelState: ListModelStateHolder<SectionProjectAndThunderDetection> = ListModelStateHolder()
) : AbstractListModelState<SectionProjectAndThunderDetection>

@OptIn(FlowPreview::class)
class DensitiesModel(
    private var currentInterface: ApiInterface
) : AbstractListModel<DensitiesModelState, SectionProjectAndThunderDetection>(
    DensitiesModelState(
        selectedDate = DateTime.now().local.endOfDay
    )
) {
    init {
        safeLaunch {
            updateState {
                copy(
                    initialized = true
                )
            }

            load()
        }
    }

    override fun onCleared() {
        println("CLEARED MainScreenModel")

        super.onCleared()
    }

    fun setSelectedDate(date: DateTimeTz) {
        updateState {
            copy(selectedDate = date.endOfDay)
        }

        startLoadingLightning(date, states.value.selectedDateFullDay)
    }

    fun setSelectedFullDay(fullDay: Boolean) {
        updateState { copy(selectedDateFullDay = fullDay) }

        startLoadingLightning(states.value.selectedDate, fullDay)
    }

    fun previousSelectedDate() {
        changeSelectedDate(states.value.selectedDate - 30.minutes)
    }

    fun previousSelectedDateDay() {
        changeSelectedDate((states.value.selectedDate.startOfDay - 12.hours).endOfDay)
    }

    fun nextSelectedDate() {
        changeSelectedDate(states.value.selectedDate + 30.minutes)
    }

    fun nextSelectedDateDay() {
        changeSelectedDate((states.value.selectedDate.endOfDay + 12.hours).endOfDay)
    }

    fun savePdf(project: Project, instance: ThunderDetectionActivity) = safeLaunch {
        saveFile("incidence_report", "pdf") {
            currentInterface.downloadIncidenceReport(project, instance)
        }
    }

    private fun changeSelectedDate(date: DateTimeTz) {
        date.let {
            launch {
                updateState {
                    copy(selectedDate = it)
                }
            }

            startLoadingLightning(it, states.value.selectedDateFullDay)
        }
    }

    private val loadStrikeRadarData = LoadStrikeRadarData(currentInterface)
    private val scope = CoroutineScope(DefaultDispatcher + SupervisorJob())

    @OptIn(ExperimentalClusteringApi::class)
    private fun startLoadingLightning(date: DateTimeTz, fullDay: Boolean) = safeLaunch {
        scope.async {
            updateState {
                copy(
                    loading = true,
                    modelState = modelState.copy(state = ListModelState.LOADING)
                )
            }

            val result = try {
                loadStrikeRadarData.startLoadingLightningForDensitiesCertificates(
                    date,
                    fullDay,
                    true
                )
            } catch (_: LoadStrikeRadarData.LoadStrikeRadarCanceledException) {
                // nothing
                return@async
            } catch (_: Throwable) {
                updateState {
                    copy(
                        loading = false,
                        modelState = modelState.copy(state = ListModelState.ERROR)
                    )
                }
                return@async
            }

            println("having result ${result.size} size")
            println("having results -> ${result.filter { it.less1Km > 0 }.size}")
            println("having results -> ${result.filter { it.less2Km > 0 }.size}")

            updateState {
                copy(
                    loading = false,
                    modelState = modelState.copy(
                        state = ListModelState.LOADED,
                        objects = result,
                        filtered = result
                    )
                )
            }
        }
    }

    override fun load() {
        startLoadingLightning(states.value.selectedDate, states.value.selectedDateFullDay)
    }

    override fun isMatch(
        entity: SectionProjectAndThunderDetection,
        filter: String
    ): Boolean {
        TODO("Not yet implemented")
    }

    override fun onNewStateHolder(newHolder: ListModelStateHolder<SectionProjectAndThunderDetection>) {
        updateState {
            copy(modelState = newHolder)
        }
    }
}
